import 'react-app-polyfill/ie11';
import React from 'react';
import { render } from 'react-dom';
import { Route, HashRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import App from './components/App';
import rootReducer from './reducers';

require('../style/index.scss');


/**
 * @param {{__DEV__:string}} dev environment
 */
if (__DEV__) {
  const immutable = require('immutable');
  const installDevTools = require('immutable-devtools');
  installDevTools(immutable);
}

/**
 * @param {{__REDUX_DEVTOOLS_EXTENSION_COMPOSE__:string}} data
 */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

render((
  <Provider store={store}>
    <Router>
      <Route path="/" component={App} />
    </Router>
</Provider>
), document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/js/index.jsx